import {Form} from '../../../../application/forms/form';

class VerificationForm extends Form
{
    get data() {
        return {
            url: this.container.querySelector('[name="url"]').value,
            'confidential-agree': 1,
        };
    }
}

export {VerificationForm};
